// extracted by mini-css-extract-plugin
export var addToCartButton = "_r7-b";
export var arrowButtonContainer = "_r7-9";
export var arrowButtonIcon = "_r7-a";
export var carouselArrowButton = "_r7-6";
export var carouselElementContainer = "_r7-1";
export var left = "_r7-7";
export var productDisplayCarouselContainer = "_r7-0";
export var productTileContainer = "_r7-2";
export var productTileImage = "_r7-4";
export var productTileImageContainer = "_r7-3";
export var productTileTitle = "_r7-5";
export var right = "_r7-8";
export var sliderOverflow = "_r7-c";